import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth, useProtectedContent } from '../../context/AuthContext'
import callAPI from '../../helpers/callAPI'

export default function Campaign(props) {
    /*
        Allowed props:
            status: highlight, active, cancelled
    */

    // TODO - need to change the statuses for campaign
    const auth = useAuth()
    const showEditCampaign = useProtectedContent(auth.permissions, 'campaign_settings')

    let classes = 'mb_element'

    const [isNew, setIsNew] = useState(false)

    useEffect(() => {
        let isMounted = true

        const loadIsNew = async () => {
            const campaignId = props.oid || props.campaignId || false

            if (!campaignId || !(Number(props.affiliateId) > 0)) {
                if (isMounted) {
                    setIsNew(false)
                }
                return
            }

            const result = await callAPI(`campaign/${campaignId}/${props.affiliateId}/isNew`, 'GET')

            if (isMounted) {
                setIsNew(Boolean(result && result.isNew))
            }
        }

        loadIsNew()

        return () => {
            isMounted = false
        }
    }, [props.oid, props.campaignId, props.affiliateId])

    if (props.status) {
        if (props.status.toUpperCase() === 'CANCELLED' || props.status.toUpperCase() === 'C') {
            classes = `mb-element cancelled`
        }
    }

    if (props.green) {
        classes = `mb-element active`
    }

    let url = props.oid ? `/campaign/${props.oid}` : ''

    return (
        <div>
            {showEditCampaign && props.oid ? (
                <Link className="mr-2" to={`/campaign/${props.oid}/settings`}>
                    <FontAwesomeIcon icon="cog" />
                </Link>
            ) : (
                ''
            )}
            <Link className={classes} to={{ pathname: url }}>
                <span className="name">{props.name} {props.affiliateStatus && props.affiliateStatus !== 'A' && <>⛔</>} {isNew && <span title="New">🆕</span>}</span>
            </Link>
        </div>
    )
}
